var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"text-h6 font-weight-regular green--text"},[_vm._v(" Existing Boardmatch user \""+_vm._s(_vm.username)+"\" will be used. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }